module.exports = __webpack_public_path__ + "img/chemicals-img-1.8989269c.png";